import axiosInstance from "../../../api/axiosInstance";
import { endpoints } from "../../../services/endpoints";
import {
    quizFirstAttemptRequest,
    quizFirstAttemptSuccess,
    quizFirstAttemptError,
} from "../../slices/dashboard/GetQuizFirstAttemptSlice";

export const GetQuizFirstAttemptApi = (currentPage = 1, limit = 5, searchTerm = "") => {
    return async (dispatch) => {
        try {
            dispatch(quizFirstAttemptRequest());
            const response = await axiosInstance({
                method: "GET",
                url: endpoints.quizFirstAttemptStats,
                params: { 
                    currentPage: Number(currentPage),  // ensure number not string
                    limit: Number(limit), 
                    searchTerm 
                },
                headers: { "Content-Type": "application/json" },
            });
            return dispatch(quizFirstAttemptSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(quizFirstAttemptError(_error));
        }
    };
};